<template>
  <div class="ai-assistant-float" v-if="showFloatButton">
    <div class="ai-assistant-icon" @click="toggleDialog">
      <img src="@/assets/images/common/robot.png" alt="AI助手" />
      <Badge :count="unreadCount" class="badge" v-if="unreadCount > 0" />
    </div>
    <transition name="fade-slide">
      <div v-if="showDialog" class="ai-assistant-dialog" @click.stop>
        <div class="dialog-header">
          <!-- <div class="header-left">
            <img src="@/assets/images/common/robot.png" class="robot-icon" />
            <span class="title">AI助手</span>
          </div> -->
          <div class="header-center">
            <!-- 快速功能下拉 -->
            <Dropdown trigger="click" @on-click="handleFuncSelect" placement="bottom-start">
              <a href="javascript:void(0)" class="dropdown-link">
                <span>{{ currentFuncName }}</span>
                <Icon type="ios-arrow-down" />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem
                  v-for="(item, idx) in quickFuncList"
                  :key="item.id || item.agentId || idx"
                  :name="item.id != null ? item.id : item.agentId">
                  <div class="dropdown-item-content">
                    <img :src="item.agentUrl || item.image || getDefaultIcon(0)" class="item-icon" />
                    <span>{{ item.agentName || item.name }}</span>
                  </div>
                </DropdownItem>
                <DropdownItem v-if="quickFuncList.length === 0" disabled>
                  暂无智能体
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <!-- 常用问题下拉 -->
            <Dropdown trigger="click" @on-click="handleProblemSelect" placement="bottom-start">
              <a href="javascript:void(0)" class="dropdown-link">
                <Icon type="ios-help-circle-outline" />
                <span>问题</span>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, index) in problemList" :key="index" :name="index">
                  {{ item.title || item.question || item.name }}
                </DropdownItem>
                <DropdownItem v-if="problemList.length === 0" disabled>
                  暂无常用问题
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="header-right">
            <button class="close-btn" @click="closeDialog">✕</button>
          </div>
        </div>
        <div class="dialog-body">
          <ChatWindow
            ref="chatWindow"
            :agent-id="selectedAgentId"
            :keepAlive="true"
            :quickFuncList="quickFuncList"
            :problemList="problemList"
            @send-question="handleSendQuestion"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ChatWindow from './chat-window.vue'
import { Badge, Dropdown, DropdownMenu, DropdownItem, Icon } from 'view-design'

export default {
  name: 'AiAssistantFloat',
  components: {
    ChatWindow,
    Badge,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Icon
  },
  data () {
    return {
      showDialog: false,
      unreadCount: 0,
      selectedAgentId: null,
      quickFuncList: [],
      problemList: [],
      currentFuncName: '智能体选择'
    }
  },
  mounted () {
    this.bootstrapQuickAgents()
  },
  computed: {
    showFloatButton () {
      // 只在 assistant 页面不显示，其他所有页面都显示
      const routeName = this.$route.name
      const routePath = this.$route.path

      // 在 AI 助手页面隐藏浮动按钮
      if (routeName === 'assistant' || routePath === '/assistant') {
        return false
      }

      // 其他页面都显示
      return true
    }
  },
  methods: {
    /** 只请求一次 findList；无智能体时不调常用问题等依赖 agentId 的接口（与 assistant.vue 一致） */
    async bootstrapQuickAgents () {
      this.selectedAgentId = null
      this.problemList = []
      try {
        const response = await this.$request.post('/sso/hiAgent/config/findList', {})
        const { code, data } = response.data
        if (code !== 'OK') {
          this.quickFuncList = []
          this.currentFuncName = '智能体选择'
          return
        }
        const raw = data.list || data.records || data || []
        this.quickFuncList = Array.isArray(raw) ? raw : []
        if (this.quickFuncList.length === 0) {
          this.currentFuncName = '智能体选择'
          return
        }
        const first = this.quickFuncList[0]
        const aid = first.id != null ? first.id : first.agentId
        if (!aid) {
          this.currentFuncName = '智能体选择'
          return
        }
        this.selectedAgentId = aid
        this.currentFuncName = first.agentName || first.name || '智能体选择'
        await this.getProblemList(aid)
      } catch (err) {
        console.error('获取智能体列表失败:', err)
        this.quickFuncList = []
        this.currentFuncName = '智能体选择'
      }
    },

    async getProblemList (agentId) {
      if (!agentId) {
        this.problemList = []
        return
      }
      try {
        const requestData = {
          pageNum: 1,
          pageSize: 10,
          agentId
        }
        const response = await this.$request.post('/sso/problem/findPageList', requestData)
        const { code, data } = response.data
        if (code === 'OK') {
          this.problemList = data.list || data.records || data || []
        }
      } catch (error) {
        console.error('获取常用问题列表失败:', error)
        this.problemList = []
      }
    },

    getDefaultIcon (index) {
      const icons = [
        require('@/assets/images/common/richeng.png'),
        require('@/assets/images/common/renwu.png'),
        require('@/assets/images/common/zhishi.png'),
        require('@/assets/images/common/shuju.png')
      ]
      return icons[index % icons.length]
    },

    handleFuncSelect (agentId) {
      const selectedFunc = this.quickFuncList.find(
        item => item.id === agentId || item.agentId === agentId || String(item.id) === String(agentId)
      )
      if (selectedFunc) {
        const aid = selectedFunc.id != null ? selectedFunc.id : selectedFunc.agentId
        this.currentFuncName = selectedFunc.agentName || selectedFunc.name || '智能体选择'
        this.selectedAgentId = aid
        // 通知子组件切换agent
        if (this.$refs.chatWindow) {
          this.$refs.chatWindow.switchAgent(aid)
        }
        this.getProblemList(aid)
      }
    },

    handleProblemSelect (index) {
      const problem = this.problemList[index]
      if (problem) {
        const questionText = problem.title || problem.question || problem.name
        this.handleSendQuestion(questionText)
      }
    },

    handleSendQuestion (questionText) {
      if (this.$refs.chatWindow) {
        this.$refs.chatWindow.sendQuickQuestion(questionText)
      }
    },
    toggleDialog () {
      this.showDialog = !this.showDialog
      if (this.showDialog) {
        this.unreadCount = 0
      }
    },
    openDialog () {
      this.showDialog = true
      this.unreadCount = 0
    },
    closeDialog () {
      this.showDialog = false
    }
  }
}
</script>

<style scoped lang="less">
.ai-assistant-float {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;

  .ai-assistant-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.5);
    transition: all 0.3s ease;
    position: relative;
    z-index: 10001;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 25px rgba(102, 126, 234, 0.7);
    }

    img {
      width: 70%;
      height: 70%;
      object-fit: contain;
    }

    .badge {
      position: absolute;
      top: -5px;
      right: -5px;
    }
  }

  .ai-assistant-dialog {
    position: fixed;
    bottom: 100px;
    right: 30px;
    width: 375px;
    height: 600px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    z-index: 10000;
    display: flex;
    flex-direction: column;
    transform-origin: bottom right;

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background: #f8f9fa;
      border-bottom: 1px solid #eee;

      .header-left {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;

        .robot-icon {
          width: 24px;
          height: 24px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }
      }

      .header-center {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;
        justify-content: flex-start;

        .dropdown-link {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px 10px;
          border-radius: 4px;
          font-size: 13px;
          color: #666;
          background: #fff;
          border: 1px solid #e8eaec;
          transition: all 0.3s;
          white-space: nowrap;

          &:hover {
            color: #2d8cf0;
            border-color: #2d8cf0;
            background: #f0f7ff;
          }

          i {
            font-size: 14px;
          }
        }

        /deep/ .ivu-dropdown-menu {
          max-height: 300px;
          overflow-y: auto;
        }

        .dropdown-item-content {
          display: flex;
          align-items: center;
          gap: 8px;

          .item-icon {
            width: 20px;
            height: 20px;
            border-radius: 4px;
          }
        }
      }

      .header-right {
        flex-shrink: 0;

        .close-btn {
          background: none;
          border: none;
          color: #999;
          font-size: 18px;
          cursor: pointer;
          padding: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            color: #666;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 4px;
          }
        }
      }
    }

    .dialog-body {
      flex: 1;
      overflow: hidden;
      position: relative;
    }
  }
}

// 动画效果
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter, .fade-slide-leave-to {
  opacity: 0;
  transform: scale(0.8) translate(20px, 20px);
}

// 移动端全屏适配
@media (max-width: 768px) {
  .ai-assistant-float {
    .ai-assistant-dialog {
      width: 100vw;
      height: 100vh;
      bottom: 0;
      right: 0;
      border-radius: 0;
    }
  }
}
</style>
